import React from "react";

const GameVignette = (props) => {
  let vignette = require(`../../../assets/img/${props.game.vignette_url}`);
  let vignettex2 = require(`../../../assets/img/${
    props.game.vignette_url.slice(0, -4) +
    "@2x" +
    props.game.vignette_url.slice(-4)
  }`);

  return (
    <>
      <img
        className="gamesList__img"
        src={vignette}
        srcSet={`${vignettex2} 2x`}
        alt={props.game.game}
      />
      <div className="gamesList__infos">
        <span className="gamesList__gameName">{props.game.game}</span>
        <span className="gamesList__nbrPost">
          {props.game.nbr_posts} annonce{props.game.nbr_posts > 1 && "s"}
        </span>
      </div>
    </>
  );
};

export default GameVignette;
